<template>
  <div>
    <el-card style="margin-bottom: 20px">
      <div class="flex-items">
        <el-select
          v-model="Pid"
          placeholder="请选择一级分类"
          @change="onClickSelect"
        >
          <el-option
            v-for="item in List"
            :key="item.Id"
            :label="item.Name"
            :value="item.Id"
          >
          </el-option>
        </el-select>
        <el-input
          v-model="Name"
          style="width: 200px; margin-left: 20px"
          placeholder="请输入内容"
        ></el-input>
        <el-button
          style="margin-left: 20px"
          type="primary"
          @click="ManageTv_TwoCateInfo"
          >查询</el-button
        >
        <el-button style="margin-left: 20px" type="primary" @click="onClickAdd"
          >新增</el-button
        >
      </div>
    </el-card>
    <el-table :data="tableData" border style="width: 100%">
      <el-table-column label="序号" width="60" align="center">
        <template slot-scope="scope">
          {{ scope.$index + (PageIndex - 1) * PageSize + 1 }}
        </template>
      </el-table-column>
      <el-table-column prop="OneCateName" label="一级分类名称" align="center">
      </el-table-column>
      <el-table-column prop="Name" label="名称" align="center">
      </el-table-column>
      <el-table-column label="课程描述" align="center">
        <template slot-scope="scope">
          <el-popover
            placement="top-start"
            title="课程描述"
            width="500"
            trigger="hover"
          >
            <div>{{ scope.row.Description }}</div>
            <span slot="reference">{{
              scope.row.Description.substr(0, 30) + "..."
            }}</span>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="Author" label="作者" align="center">
      </el-table-column>
      <el-table-column label="封面" align="center">
        <template slot-scope="scope">
          <el-image
            style="width: 2.25rem; height: 1.5rem"
            :src="scope.row.Image"
            fit="cover"
          ></el-image>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="Description" label="描述" align="center">
      </el-table-column> -->
      <el-table-column prop="CreateTime" label="创建时间" align="center">
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="onClickEdit(scope.row)"
            >编辑</el-button
          >
          <el-button
            type="text"
            style="color: red"
            @click="onClickDelete(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="PageIndex"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="PageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      style="text-align: center;padding:20px; 0 0 0"
    >
    </el-pagination>
    <el-dialog :title="Title" :visible.sync="dialogVisible" width="30%">
      <div>
        <el-form
          :model="ruleForm"
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
          label-position="top"
        >
          <el-form-item label="分类" prop="parentId">
            <el-select v-model="ruleForm.parentId" placeholder="请选择一级分类">
              <el-option
                v-for="item in List"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="名称" prop="name">
            <el-input v-model="ruleForm.name"></el-input>
          </el-form-item>
          <el-form-item label="课程描述" prop="description">
            <el-input type="textarea" v-model="ruleForm.description"></el-input>
          </el-form-item>
          <el-form-item label="封面" prop="image">
            <el-upload
              class="avatar-uploader"
              action="/api/Img/UploadImage/"
              :headers="token"
              :show-file-list="false"
              :on-success="handleAvatarSuccessChildImage"
              :before-upload="beforeAvatarUpload"
            >
              <img
                v-if="ruleForm.image"
                style="width: 2.25rem; height: 1.5rem"
                :src="ruleForm.image"
                class="avatar"
              />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>

          <el-form-item label="作者" prop="author">
            <el-input v-model="ruleForm.author"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="ManageAddUpdateTv_TwoCateInfo('ruleForm')"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetCateInfo,
  ManageTv_TwoCateInfo,
  ManageDeleteTv_CateInfo,
  ManageAddUpdateTv_TwoCateInfo,
} from "../../api/api";

export default {
  data() {
    return {
      Pid: null,
      List: [],
      Name: "",
      tableData: [],
      PageIndex: 1,
      PageSize: 10,
      total: 0,
      Title: "",
      dialogVisible: false,
      ruleForm: {
        name: "",
        Id: 0,
        description: "",
        image: "",
        parentId: null,
        author: "",
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        description: [
          { required: true, message: "请输入课程描述", trigger: "blur" },
        ],
        image: [{ required: true, message: "请上传图片", trigger: "change" }],
        parentId: [
          { required: true, message: "请选择一级分类", trigger: "change" },
        ],
        author: [
          { required: true, message: "请输入作者名称", trigger: "blur" },
        ],
      },
      //编辑单个
      token: {
        Authorization: "Bearer ",
      },
    };
  },
  async created() {
    await this.GetCateInfo();
    await this.ManageTv_TwoCateInfo();
  },
  watch: {
    dialogVisible(val) {
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate();
      });
    },
  },
  methods: {
    ResetData() {
      this.ruleForm = {
        name: "",
        Id: 0,
        description: "",
        image: "",
        parentId: null,
        author: "",
      };
    },
    async ManageAddUpdateTv_TwoCateInfo(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          let res = await ManageAddUpdateTv_TwoCateInfo(this.ruleForm);
          if (res.data.success) {
            this.$message({
              type: "success",
              message: "成功",
            });
            this.ResetData();
            this.ManageTv_TwoCateInfo();
            this.dialogVisible = false;
          } else {
            this.$message({
              type: "error",
              message: res.data.msg,
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleAvatarSuccessChildImage(res) {
      if (res.success) {
        this.ruleForm.image = res.response;
      } else {
        this.$message.warning("上传失败");
      }
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isJPG && !isPNG) {
        this.$message.error("上传图片只能是 JPG或png 格式!");
      }
      if (!isLt2M) {
        this.$message.error("上传图片大小不能超过 2MB!");
      }
      return (isJPG || isPNG) && isLt2M;
    },
    onClickAdd() {
      this.Title = "添加";
      this.dialogVisible = true;
    },
    onClickEdit(item) {
      console.log(item);
      this.Title = "修改";
      this.ruleForm = {
        name: item.Name,
        Id: item.Id,
        description: item.Description,
        image: item.Image,
        parentId: item.ParentId,
        author: item.Author,
      };
      this.dialogVisible = true;
    },
    onClickDelete(item) {
      this.$confirm("是否删除当前分类, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(async () => {
          let xhr = await ManageDeleteTv_CateInfo({
            ids: [item.Id],
          });
          if (xhr.data.success) {
            this.$message({
              type: "success",
              message: "删除成功",
            });
            this.ManageTv_TwoCateInfo();
          } else {
            this.$message({
              type: "error",
              message: "删除失败",
            });
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    onClickSelect(e) {
      this.ManageTv_TwoCateInfo();
    },
    handleCurrentChange(val) {
      this.PageIndex = val;
      this.ManageTv_TwoCateInfo();
    },
    handleSizeChange(val) {
      this.PageSize = val;
      this.ManageTv_TwoCateInfo();
    },
    async ManageTv_TwoCateInfo() {
      let res = await ManageTv_TwoCateInfo({
        ParentId: this.Pid ? this.Pid : 0,
        PageIndex: this.PageIndex,
        PageSize: this.PageSize,
        Name: this.Name,
      });
      if (res.data.success) {
        this.tableData = res.data.response.data;
        this.total = res.data.response.dataCount;
      } else {
        this.tableData = [];
        this.total = 0;
      }
    },
    async GetCateInfo() {
      let res = await GetCateInfo();
      if (res.data.success) {
        this.List = res.data.response;
      }
    },
  },
};
</script>
<style lang="less" scoped>
.tui-courseText {
  overflow: hidden;
  text-overflow: ellipsis; /* 超出部分省略号 */
  word-break: break-all; /* break-all(允许在单词内换行。) */
  display: -webkit-box; /* 对象作为伸缩盒子模型显示 */
  -webkit-box-orient: vertical; /* 设置或检索伸缩盒对象的子元素的排列方式 */
  -webkit-line-clamp: 2; /* 显示的行数 */
}
.avatar-uploader .el-upload {
  border: 1px dashed #dcdfe6;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 320px;
  height: 180px;
  line-height: 180px;
  text-align: center;
  border: 1px solid #dcdfe6;
}
.avatar {
  width: 320px;
  height: 180px;
  display: block;
  object-fit: cover;
}
.avatars {
  width: 95px;
  height: 108px;
  display: block;
}
.avatarlist {
  width: 225px;
  height: 241.5px;
  display: block;
}
.avatar-uploader-iconss {
  padding: 10px 0px;
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  line-height: 30px;
  /* height: 120px; */
  text-align: center;
}
</style>